import * as z from 'zod';
import * as ba from './base';
import { SCRIPT_SCHEMA } from '../scripting';
import { isComponentContext } from '../helpers';

export interface ScriptActionArgs {
  value: Function;
}

export class ScriptAction extends ba.Action<ScriptActionArgs, null> {
  static get manifest() {
    return {
      name: 'script',
      schema: z.object({
        value: SCRIPT_SCHEMA()
      })
    };
  }

  static callableParameterNames = ['value'];

  async handle(event: ba.ActionEvent, args: ScriptActionArgs) {
    await args.value();
    return null;
  }
}
